function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 57 9"
}, props), React.createElement("path", {
  d: "M48.27 9l.859-3.328-2.879-2.238 3.803-.296L51.532 0l1.479 3.138 3.803.296-2.879 2.238L54.793 9l-3.261-1.764L48.27 9zM2.02 9l.859-3.328L0 3.434l3.803-.296L5.282 0 6.76 3.138l3.803.296-2.879 2.238L8.543 9 5.282 7.236 2.02 9zM13.583 9l.858-3.328-2.879-2.238 3.803-.296L16.845 0l1.478 3.138 3.803.296-2.879 2.238L20.106 9l-3.262-1.764L13.583 9zM25.145 9l.859-3.328-2.879-2.238 3.803-.296L28.407 0l1.479 3.138 3.803.296-2.879 2.238L31.668 9l-3.261-1.764L25.145 9zM36.708 9l.858-3.328-2.879-2.238 3.803-.296L39.97 0l1.478 3.138 3.803.296-2.878 2.238L43.23 9l-3.262-1.764L36.708 9z",
  fill: "#D69F1F"
})));